module.exports = __webpack_public_path__ + "static/media/lord-jesus-christ-candle-1.10466e3a.gif";